import { OnboardingStepCommon, Content, VideoTour } from './OnboardingStepCommon';

const OnboardingStepThree = ({ videoRef }) => {
  return (
    <OnboardingStepCommon>
      <VideoTour ref={videoRef} name='onboarding-3' />
      <Content>
        <small className='black'>Features you can try on the playground:</small>
        <h3>Generate legal text</h3>
        <p>
          <small>
            Click the Lizzy icon on the bottom right to launch the Lizzy menu. 
            Ask for legal text in free language or use the preset action buttons for common actions
          </small>
        </p>
      </Content>
    </OnboardingStepCommon>
  );
}

export default OnboardingStepThree;